import { NavigationSection } from "@common/data-models/service/navigation-section";
import { NavigationDragDropData } from "@common/data-models/navigation/navigation-drag-drop-data";
import { NavigationDragDropActions } from "@common/enums/navigation-drag-drop-actions";
import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { Util } from "@common/utils/util";
import { ViewStateRecord } from "@common/data-models/records/viewstate-record";
import { RSSFeedViewStateRecord } from "@common/data-models/records/rss-feed-viewstate-record";

export class NavigationItem implements IDeepCopy<NavigationItem> {
    public static SYSTEM_SEARCH_GUID: string = "C999F440-D24C-6664-B7D9F19DBCX77D424";
    public static SYSTEM_DEFAULT_VIEW_GUID: string = "998";
    public static SYSTEM_NEW_VIEW_GUID: string = "997";
    public static SYSTEM_CURRENT_VIEW_GUID: string = "C999F440-D24C-44E4-B7D9F19DBCX77D424";
    public static SYSTEM_CURRENT_TOPIC_GUID: string = "995";
    public static SYSTEM_CURRENT_ASSIGNMENT_GUID: string = "994";

    public static USER_NAVIGATION_ITEMS_OFFSET: number = 100;

    public Database: string;
    public Path: string;
    public Guid: string;
    public Hidden: boolean;
    public IsDefault: boolean;
    public Order: number;
    public SectionID: number;
    public SectionPath: string;
    public GroupPath: string;
    public System: boolean;
    public Url: Array<string>;
    public Enterprise: boolean;
    public Label: string;
    public ViewState: ViewStateRecord;

    public get Icon(): string {
        if (this.ViewState instanceof RSSFeedViewStateRecord) {
            return "rss_feed";
        }
        return "layers";
    }

    public get dragData() {
        let data: NavigationDragDropData = new NavigationDragDropData();
        data.action = NavigationDragDropActions.Reorder;
        data.data = this;
        return data;
    }
    
    public isSystem(): boolean {
        return (this.SectionID == NavigationSection.SYSTEM_SECTION_ID);
    }

    public isSystemSearch(): boolean {
        return (this.Guid == NavigationItem.SYSTEM_SEARCH_GUID);
    }

    public isNewView(): boolean {
        return (this.Guid == NavigationItem.SYSTEM_NEW_VIEW_GUID && !this.ViewState.guid);
    }

    public isCurrentView(): boolean {
        return (this.Guid == NavigationItem.SYSTEM_CURRENT_VIEW_GUID);
    }

    public isDefaultView(): boolean {
        return (this.SectionID == NavigationSection.SYSTEM_DEFAULT_SECTION_ID);
    }

    public isCurrentTopicView(): boolean {
        return (this.Guid == NavigationItem.SYSTEM_CURRENT_TOPIC_GUID);
    }

    public isSystemDefaultViewEmpty(): boolean {
        return (!this.ViewState || (this.ViewState && this.ViewState.guid == NavigationItem.SYSTEM_DEFAULT_VIEW_GUID));
    }

    public urlAsString(): string {
        return this.Url.join('/')
    }

    public deepCopy(): NavigationItem {
        let newNavigationItem = Util.deepCopy<NavigationItem>(this);
        newNavigationItem.ViewState = null;
        newNavigationItem.Url = null;
        newNavigationItem.SectionPath = null;
        return newNavigationItem;
    }
}
